import { Type } from "@angular/core";
import { ApplicationRef, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import _get from "lodash/get";
import _flatten from "lodash/flatten";
import { VenuesSearchComponent } from "apps-module/app/entry-modules/venues-search/venues-search.component";
import { VenuesSearchModule } from "apps-module/app/entry-modules/venues-search/venues-search.module";
import { VacanciesSearchComponent } from "apps-module/app/entry-modules/vacancies-search/vacancies-search.component";
import { VacanciesSearchModule } from "apps-module/app/entry-modules/vacancies-search/vacancies-search.module";
import { AssistantsProfileSearchComponent } from "apps-module/app/entry-modules/assistants-profile-search/assistants-profile-search.component";
import { AssistantsProfileSearchModule } from "apps-module/app/entry-modules/assistants-profile-search/assistants-profile-search.module";
import { EventSearchComponent } from "apps-module/app/entry-modules/event-search/event-search.component";
import { EventSearchModule } from "apps-module/app/entry-modules/event-search/event-search.module";
import { NewsSearchModule } from "apps-module/app/entry-modules/news-search/news-search.module";
import { NewsSearchComponent } from "apps-module/app/entry-modules/news-search/news-search.component";
import { DirectorySearchComponent } from "apps-module/app/entry-modules/advanced-search/directory-search/directory-search.component";
import { SearchBarComponent } from "apps-module/app/entry-modules/advanced-search/search-bar/search-bar.component";
import { SavedSearchesBarComponent } from "apps-module/app/entry-modules/advanced-search/saved-searches/saved-searches-bar/saved-searches-bar.component";
import { SavedSearchesPageComponent } from "apps-module/app/entry-modules/advanced-search/saved-searches/saved-searches-page/saved-searches-page.component";
import { AdvancedSearchModule } from "apps-module/app/entry-modules/advanced-search/advanced-search.module";
import {BookletPageComponent} from "./entry-modules/booklet/booklet-page/booklet-page.component";
import {AddToBookletComponent} from "./entry-modules/booklet/add-to-booklet/add-to-booklet.component";
import {ContentSearchComponent} from "./entry-modules/advanced-search/content-search/content-search.component";
import {AdvancedSearchComponent} from "./entry-modules/advanced-search/advanced-search.component";

const entryComponents: Array<Type<any>> = [
    VenuesSearchComponent,
    VacanciesSearchComponent,
    EventSearchComponent,
    AssistantsProfileSearchComponent,
    NewsSearchComponent,
    DirectorySearchComponent,
    SearchBarComponent,
    SavedSearchesBarComponent,
    SavedSearchesPageComponent,
    AddToBookletComponent,
    BookletPageComponent,
    ContentSearchComponent,
    AdvancedSearchComponent
];

@NgModule({
    imports: [
        BrowserModule,
        VenuesSearchModule,
        VacanciesSearchModule,
        EventSearchModule,
        AssistantsProfileSearchModule,
        NewsSearchModule,
        AdvancedSearchModule
    ],
    entryComponents: entryComponents
})
export class AppModule {
    public ngDoBootstrap(applicationRef: ApplicationRef): void {
        entryComponents
            .map(component => ({
                component: component,
                nodes: [...document.querySelectorAll( _get(component, "SELECTOR"))] as Array<Node>
            }))
            .forEach(relation => {
                relation.nodes.forEach(node => {
                    applicationRef.bootstrap(relation.component, node);
                });
            });
    }
}
